module.exports = __webpack_public_path__ + "assets/bfda53ee7c5efc97c1bf27534ad659a9.mp3";